module.exports = __webpack_public_path__ + "img/01.1cc2f5bb.webp";